/* Store Designer: collection page (option B). Zone switch and tags, Show more, sort, floating filter bar.
   The page may be one section or split into parts (zone line, filter bar, products...), so it works on the whole document. */
(function () {
  if (window.__sdCollectionB) return;
  window.__sdCollectionB = true;

  function readZone() {
    var m = document.cookie.match(/(?:^|; )userLocationData=([^;]*)/);
    if (!m) return null;
    try {
      var d = JSON.parse(decodeURIComponent(m[1]));
      return Number.isFinite(d.zone) ? d.zone : null;
    } catch (e) { return null; }
  }

  function zonesOf(card) {
    var raw = card.getAttribute('data-zones') || '';
    var nums = raw.match(/\d+/g);
    if (!nums) return [];
    nums = nums.map(Number);
    // "3-9" style ranges: fill in the zones between
    if (raw.indexOf(',') === -1 && nums.length === 2 && nums[1] > nums[0]) {
      var out = [];
      for (var i = nums[0]; i <= nums[1]; i++) out.push(i);
      return out;
    }
    return nums;
  }

  function tagCards(zone) {
    document.querySelectorAll('.sd-cb-card').forEach(function (card) {
      var inZone = zone != null && zonesOf(card).indexOf(zone) !== -1;
      card.classList.toggle('in-zone', inZone);
      var tag = card.querySelector('.sd-cb-zb');
      if (tag) tag.hidden = !inZone;
    });
  }

  function init() {
    var meta = document.querySelector('.sd-cb');
    if (!meta) return;
    var coll = meta.getAttribute('data-coll') || 'plants';
    var param = meta.getAttribute('data-zone-param');
    var sws = document.querySelectorAll('[data-sd-zswitch]');
    var labels = document.querySelectorAll('[data-sd-zlabel]');
    var zoneEls = document.querySelectorAll('[data-sd-zone]');
    var zipBox = document.querySelector('[data-sd-zip]');
    var zipToggles = document.querySelectorAll('[data-sd-zip-toggle]');
    var grid = document.querySelector('[data-sd-grid]');
    var zone = readZone();

    function render() {
      zoneEls.forEach(function (el) { el.textContent = zone != null ? 'Zone ' + zone : 'not set'; });
      document.querySelectorAll('.bzone').forEach(function (el) { el.classList.toggle('is-unset', zone == null); });
      zipToggles.forEach(function (t) { t.textContent = zone != null ? 'Change' : 'Set my zone'; });
      labels.forEach(function (l) { l.textContent = 'Only show ' + coll + ' for ' + (zone != null ? 'Zone ' + zone : 'my zone'); });
      tagCards(zone);
      hold();
    }

    function openZip() {
      if (!zipBox) return;
      var open = !zipBox.classList.contains('is-open');
      zipBox.classList.toggle('is-open', open);
      zipToggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        zipBox.scrollIntoView({ block: 'nearest' });
        var i = zipBox.querySelector('input'); if (i) i.focus();
      }
    }

    zipToggles.forEach(function (t) { t.addEventListener('click', function () {
      if (t.closest('[data-sd-bar]') && zipBox && !zipBox.classList.contains('is-open')) window.scrollTo({ top: 0, behavior: 'smooth' });
      openZip();
    }); });

    sws.forEach(function (sw) { sw.addEventListener('click', function () {
      if (zone == null) { closeFd(true); window.scrollTo({ top: 0 }); openZip(); return; }
      var on = sw.getAttribute('aria-pressed') !== 'true';
      if (param) {
        var url = new URL(location.href);
        url.searchParams.delete(param);
        url.searchParams.delete('page');
        if (on) url.searchParams.append(param, String(zone));
        location.href = url.toString();
        return;
      }
      sws.forEach(function (s) { s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (grid) grid.classList.toggle('sd-zonly', on);
    }); });

    // Filter panel: slides in from the right (from the bottom on phones), counts update as you tick
    var fd = document.querySelector('[data-sd-fd]');
    var form = fd && fd.querySelector('[data-sd-fdform]');
    function openFd(group) {
      if (!fd) return;
      if (!fd.open) {
        if (fd.showModal) fd.showModal(); else fd.setAttribute('open', '');
        document.documentElement.classList.add('sd-lock');
        requestAnimationFrame(function () { requestAnimationFrame(function () { fd.classList.add('is-in'); }); });
      }
      if (group) {
        var g = fd.querySelector('[data-sd-fg="' + group + '"]');
        if (g) { g.open = true; setTimeout(function () { g.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 120); }
      }
    }
    function closeFd(now) {
      if (!fd || !fd.open) return;
      fd.classList.remove('is-in');
      document.documentElement.classList.remove('sd-lock');
      setTimeout(function () { if (fd.close) fd.close(); else fd.removeAttribute('open'); }, now ? 0 : 300);
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sd-fdopen]');
      if (t) { e.preventDefault(); openFd(t.getAttribute('data-sd-fdopen')); }
    });
    if (fd) {
      fd.addEventListener('click', function (e) {
        if (e.target === fd) closeFd();
        if (e.target.closest('[data-sd-fdclose]')) closeFd();
        var all = e.target.closest('[data-sd-sall]');
        if (all) {
          var box = all.previousElementSibling;
          var open = box.classList.toggle('is-all');
          all.textContent = open ? 'Show fewer' : 'Show all ' + box.children.length;
        }
      });
      fd.addEventListener('cancel', function (e) { e.preventDefault(); closeFd(); });
    }
    function params() {
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return p;
    }
    function groupCounts() {
      fd.querySelectorAll('[data-sd-fg]').forEach(function (g) {
        var b = g.querySelector('[data-sd-gn]');
        if (!b) return;
        var n = g.querySelectorAll('input[type=checkbox]:checked').length;
        if (!n) { g.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value !== '') n = 1; }); }
        b.textContent = n; b.hidden = !n;
      });
    }
    var timer, seq = 0;
    function refresh() {
      groupCounts();
      var p = params();
      p.set('section_id', fd.getAttribute('data-section'));
      var mine = ++seq;
      form.classList.add('is-busy');
      fetch(form.action + '?' + p.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (mine !== seq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nf = doc.querySelector('[data-sd-fd]');
          if (!nf) return;
          var t = nf.querySelector('[data-sd-fdtotal]');
          if (t) fd.querySelectorAll('[data-sd-fdtotal]').forEach(function (el) { el.textContent = t.textContent; });
          nf.querySelectorAll('input[type=checkbox]').forEach(function (ni) {
            var oi = null;
            form.querySelectorAll('input[type=checkbox]').forEach(function (x) { if (x.name === ni.name && x.value === ni.value) oi = x; });
            if (!oi) return;
            var lab = oi.closest('label'), nl = ni.closest('label');
            var c = lab && lab.querySelector('[data-c]'), nc = nl && nl.querySelector('[data-c]');
            if (c && nc) c.textContent = nc.textContent;
            var dead = !oi.checked && nc && nc.textContent.trim() === '0';
            oi.disabled = !!dead;
            if (lab) lab.classList.toggle('off', !!dead);
          });
        })
        .catch(function () {})
        .then(function () { if (mine === seq) form.classList.remove('is-busy'); });
    }
    if (form) {
      form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(refresh, 200); });
      form.addEventListener('input', function (e) { if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(refresh, 500); } });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        location.href = form.action + (params().toString() ? '?' + params().toString() : '');
      });
    }

    window.addEventListener('tn:zone-detected', function (e) {
      zone = e.detail && Number(e.detail.zoneNumber);
      if (!Number.isFinite(zone)) zone = null;
      if (zipBox) zipBox.classList.remove('is-open');
      render();
    });

    // Sort
    var sort = document.querySelector('[data-sd-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    });

    // Show more: load the next page into the grid
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sd-more-btn]');
      if (!btn || !grid) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var box = document.querySelector('[data-sd-more]');
      if (box) box.classList.add('is-loading');
      fetch(btn.href, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.getElementById(grid.id);
          if (next) Array.prototype.forEach.call(next.children, function (c) { grid.appendChild(document.importNode(c, true)); });
          var more = doc.querySelector('[data-sd-more]');
          var mine = document.querySelector('[data-sd-more]');
          if (more && mine) mine.innerHTML = more.innerHTML;
          if (mine) mine.classList.remove('is-loading');
          tagCards(zone);
          autoMore();
        })
        .catch(function () { location.href = btn.href; });
    });

    // Phones: no Show more button, the next products load as the shopper nears the end of the grid
    var phone = window.matchMedia('(max-width: 749px)');
    function autoMore() {
      var box = document.querySelector('[data-sd-more]');
      var btn = box && box.querySelector('[data-sd-more-btn]');
      if (!phone.matches || !btn || btn.getAttribute('aria-busy') === 'true') return;
      if (box.getBoundingClientRect().top < window.innerHeight + 800) btn.click();
    }
    var moreBox = document.querySelector('[data-sd-more]');
    if (moreBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) autoMore(); }, { rootMargin: '0px 0px 800px 0px' }).observe(moreBox);
    }

    // Floating filter bar: sits below the store's sticky header, and steps away once the products have scrolled past
    var bar = document.querySelector('[data-sd-bar]');
    var split = bar && bar.hasAttribute('data-sd-split');
    var host = bar && (split ? (bar.closest('.shopify-section') || bar) : bar);
    var prods = document.querySelector('[data-sd-products]');
    var prodHost = prods && (prods.closest('.shopify-section') || prods);
    var header = document.getElementById('header-component') || document.querySelector('.header-section');
    // The bar's slot keeps its full height while the stuck bar collapses, so the page never shifts
    // (a shift reads as a scroll-up to the header, which then slides back in over the bar)
    function hold() {
      if (!split || !host || bar.classList.contains('sd-stuck')) return;
      host.style.minHeight = '';
      host.style.minHeight = bar.offsetHeight + 'px';
    }
    function place() {
      if (!host) return;
      var top = 0;
      if (header) {
        var b = header.getBoundingClientRect().bottom;
        if (b > 0) top = Math.round(b);
      }
      host.style.setProperty('--sd-top', top + 'px');
      bar.classList.toggle('sd-stuck', window.scrollY > 0 && host.getBoundingClientRect().top <= top + 1);
      if (split && prodHost) {
        var past = prodHost.getBoundingClientRect().bottom < top + bar.offsetHeight;
        host.classList.toggle('sd-past', past);
      }
    }
    // The header slides in and out on its own after scrolling stops, so follow it frame by frame for a moment
    var until = 0, running = false;
    function follow() {
      until = performance.now() + 700;
      if (running) return;
      running = true;
      (function step() {
        place();
        if (performance.now() < until) requestAnimationFrame(step);
        else running = false;
      })();
    }
    window.addEventListener('scroll', follow, { passive: true });
    window.addEventListener('resize', function () { hold(); place(); });
    if (header) {
      new MutationObserver(follow).observe(header, { attributes: true });
      header.addEventListener('transitionrun', follow);
      header.addEventListener('transitionend', follow);
    }
    if (split) bar.addEventListener('transitionend', function (e) { if (e.propertyName === 'max-height') hold(); });
    hold();
    place();

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
